// extracted by mini-css-extract-plugin
export default {"BreakpointFromLarge":"(min-width: 960px)","fiveRecipesContainer":"Gf5d3ed Gf96eef G0ff43d G3d3bca Gac1cf3","fiveRecipesText":"G964e3f","leftArrow":"G85e70d"};